import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import html2canvas from 'html2canvas';

const DailyHadees = () => {
  const [hadees, setHadees] = useState(null);
  const cardRef = useRef(null); 

  useEffect(() => {
    const fetchHadees = async () => {
      const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      try {
        const { data } = await axios.get(`${BASE_URL}/api/hadees`);
        if (data && data.arabic) setHadees(data);
      } catch (err) { console.error(err); }
    };
    fetchHadees();
  }, []);

  const handleShare = async () => {
    if (!cardRef.current) return;

    try {
      const canvas = await html2canvas(cardRef.current, { 
        backgroundColor: '#155724', 
        scale: 3, 
        useCORS: true, 
        logging: false, 
      });

      canvas.toBlob(async (blob) => {
        const file = new File([blob], 'daily-hadees.png', { type: 'image/png' });
        
        const websiteLink = window.location.origin;
        const whatsappChannel = "https://whatsapp.com/channel/0029Vb8J4ZVKLaHo7nUgcC3i"; // Replace this!

        // ✅ CAPTION FIX: This is where the links become clickable in WhatsApp
        const shareText = `✨ *Hadees of the Day*\n\n` +
                          `🌐 Visit Website: ${websiteLink}\n` +
                          `📢 Join our Channel: ${whatsappChannel}`;

        if (navigator.share) {
          try {
            await navigator.share({ 
              files: [file], 
              title: 'Daily Hadees', 
              text: shareText
            });
          } catch (error) { console.log('Share dismissed'); }
        } else {
          // PC Fallback
          const link = document.createElement('a');
          link.download = 'daily-hadees.png';
          link.href = canvas.toDataURL();
          link.click();
        }
      }, 'image/png');
    } catch (err) { console.error('Screenshot failed', err); }
  };

  if (!hadees) return null;

  return (
    <div className="container my-5">
      <div className="row justify-content-center px-2">
        <div className="col-md-8 col-lg-6">
          
          <div className="card shadow-lg border-0 rounded-4 overflow-hidden">
            
            {/* --- CAPTURE TARGET --- */}
            <div 
              ref={cardRef} 
              className="position-relative" 
              style={{ 
                backgroundColor: '#155724', 
                padding: '20px'             
              }}
            >
              
              {/* Header Text (White on Green) */}
              <div className="text-center mb-3 mt-2">
                <h5 
                  className="m-0 text-white fw-bold text-uppercase" 
                  style={{ letterSpacing: '3px', fontSize: '1.2rem', fontFamily: 'serif' }}
                >
                  ✨ Hadees of the Day
                </h5>
              </div>

              {/* WHITE BOX */}
              <div className="bg-white rounded-3 p-4 text-center shadow-sm">
                
                {/* Arabic */}
                <h2 className="mb-3 text-dark fw-bold" dir="rtl" style={{ fontFamily: "'AlQalam', serif", fontSize: '1.6rem', fontWeight: 'normal', lineHeight: '1.6' }}>
                  {hadees.arabic}
                </h2>

                {/* Urdu */}
                <h4 className="mb-4" dir="rtl" style={{ fontFamily: "'JameelNooriNastaleeq', serif", fontSize: '1.5rem', fontWeight: 'normal', color: '#444', lineHeight: '1.4'}}>
                  {hadees.urdu}
                </h4>

                {/* English */}
                <p className="fst-italic text-muted mb-4" style={{ fontSize: '1.1rem' }}>
                  "{hadees.english}"
                </p>

                {/* Reference */}
                <div className="mb-4" dir="rtl">
                   <span className="fw-bold text-success" style={{ fontFamily: "'JameelNooriNastaleeq', serif", fontSize: '1.4rem' }}>
                     — {hadees.reference} —
                   </span>
                </div>

                {/* Footer Stamp */}
                <div className="mt-4 pt-3 border-top d-flex justify-content-between align-items-center" style={{ borderColor: '#e9ecef' }}>
                    {/* Link to Website */}
                  <a href="https://darululoom.online" target="_blank" rel="noreferrer" className="text-decoration-none d-flex align-items-center">
                    <img src="/images/favicon.png" alt="Logo" width="24" height="24" className="me-2" crossOrigin="anonymous" />
                    <span className="fw-bold text-dark small">Darul Uloom</span>
                  </a>

                  {/* Link to WhatsApp Channel */}
                  <a href="https://whatsapp.com/channel/0029Vb8J4ZVKLaHo7nUgcC3i" target="_blank" rel="noreferrer" className="text-decoration-none">
                    <small className="text-success fw-bold">
                      <i className="bi bi-whatsapp me-1"></i> Join Channel
                    </small>
                  </a>
                </div>

              </div>
              {/* --- End White Box --- */}

            </div>
            {/* --- END CAPTURE TARGET --- */}

            {/* Share Button (Outside) */}
            <div className="card-footer bg-white border-0 p-3 text-center">
              <button onClick={handleShare} className="btn btn-success rounded-pill px-4 fw-bold shadow-sm hover-scale">
                <i className="bi bi-whatsapp me-2"></i> Share Image
              </button>
            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default DailyHadees;